const KEY_D = 'KeyD';
const KEY_CODE_MAP = {
  69: KEY_D,
};

export default {
  data() {
    return {
      timeout: undefined,
      showDebug: false,
    };
  },
  created() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
  },
  methods: {
    onKeyDown(e) {
      if (this.timeout) {
        return;
      }

      const key = e.code || KEY_CODE_MAP[e.keyCode];

      if (key !== KEY_D) {
        return;
      }

      this.timeout = setTimeout(() => {
        this.showDebug = !this.showDebug;
      }, 2000);
    },
    onKeyUp() {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    },
  },
};
